import { ChangeDetectionStrategy, Component, HostBinding, Input, computed } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { EpcotModule } from '../common/epcot-config.service';

@Component({
    selector: 'ms-empty-media',
    templateUrl: 'empty-media.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EmptyMediaComponent {
    @Input() isEventSelected: boolean;
    @Input() isEventLive: boolean;
    @Input() emptyList: boolean;
    @Input() isExpanded: boolean;
    module = EpcotModule.Statsindicator;
    @HostBinding('class') className = 'empty-media';

    message = computed(() => {
        if (this.isEventSelected) {
            return this.isEventLive ? this.sitecore.media.NoLiveStreamingForEvent : this.sitecore.media.NoLiveStreamingForEventPrematch;
        } else {
            return (this.emptyList ? this.sitecore.media.SelectAnimationFromLiveEvents : this.sitecore.media.SelectMediaFromList)
                .replace('{{videoIcon}}', '<span class="icon-container"><vn-icon name="sports-video" size="16" /></span>')
                .replace('{{animationIcon}}', '<span class="icon-container"><vn-icon name="sports-4-match" size="16" /></span>');
        }
    });

    constructor(public sitecore: Sitecore) {}
}
